import React, { useState, useEffect } from 'react';
import { Container, Row, Col, Button, ModalHeader, ModalBody, ModalFooter, Modal, Input } from 'reactstrap';
import styled from 'styled-components';
import { GetUserInformation, OpenTicket, UpdateUserInformation } from '../../services/firestore';
import { auth } from '../../services/firebase';
import { moduleStrings } from './moduleStrings';
import firebase from 'firebase';
import { TicketStrings } from '../adminPages/tickets/ticketStrings';
import Fireworks from '../common/fireworks';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import forestWalk from "../../images/ForestHike.png";
import MonthCard from './monthCard';
import MonthModal from './monthModal';

const monthData = {
    1: {
        title: "Month 1",
        topics: [
            "Exercise Introduction",
            "Getting active",
            "Goal Setting",
            "Self-monitoring",
            "Activity tracker sheets"
        ],
        file: 'https://himalayas-space.nyc3.cdn.digitaloceanspaces.com/docs/monthly-behavioural-support-modules/Month-1.pdf',
        moduleString: moduleStrings.MonthOne
    },
    2: {
        title: "Month 2",
        topics: [
            "Types of exercise",
            "Exercise prescription",
            "Motivation regulation",
            "Overcoming barriers",
            "Activity tracker sheets"
        ],
        file: 'https://himalayas-space.nyc3.cdn.digitaloceanspaces.com/docs/monthly-behavioural-support-modules/Month-2.pdf',
        moduleString: moduleStrings.MonthTwo
    },
    3: {
        title: "Month 3",
        topics: [
            "Cancer-related cardiovascular disease",
            "Having fun with physical activity",
            "Physical activity environmental scan",
            "Activity tracking",
            "Activity tracker sheets"
        ],
        file: 'https://himalayas-space.nyc3.cdn.digitaloceanspaces.com/docs/monthly-behavioural-support-modules/Month-3.pdf',
        moduleString: moduleStrings.MonthThree
    },
    4: {
        title: "Month 4",
        topics: [
            "Exercise benefits: Mental & emotional",
            "Exercise progression & recovery",
            "Stimulus control",
            "Goal setting",
            "Self talk",
            "Activity tracker sheets"
        ],
        file: 'https://himalayas-space.nyc3.cdn.digitaloceanspaces.com/docs/monthly-behavioural-support-modules/Month-4.pdf',
        moduleString: moduleStrings.MonthFour
    },
    5: {
        title: "Month 5",
        topics: [
            "Exercise benefits: Social",
            "Social support",
            "Decision balance",
            "Activity tracker sheets"
        ],
        file: 'https://himalayas-space.nyc3.cdn.digitaloceanspaces.com/docs/monthly-behavioural-support-modules/Month-5.pdf',
        moduleString: moduleStrings.MonthFive
    },
    6: {
        title: "Month 6",
        topics: [
            "Exercise benefits: Physical function",
            "Time management",
            "Overcoming barriers",
            "Goal setting",
            "Activity tracker sheets"
        ],
        file: 'https://himalayas-space.nyc3.cdn.digitaloceanspaces.com/docs/monthly-behavioural-support-modules/Month-6.pdf',
        moduleString: moduleStrings.MonthSix
    },
    7: {
        title: "Month 7",
        topics: [
            "Exercise benefits: Fatigue",
            "Exercise maintenance",
            "Activity tracker sheets"
        ],
        file: 'https://himalayas-space.nyc3.cdn.digitaloceanspaces.com/docs/monthly-behavioural-support-modules/Month-7.pdf',
        moduleString: moduleStrings.MonthSeven
    },
    8: {
        title: "Month 8",
        topics: [
            "Stimulus control",
            "Motivation regulation",
            "Self talk",
            "Goal setting",
            "Activity tracker sheets"
        ],
        file: 'https://himalayas-space.nyc3.cdn.digitaloceanspaces.com/docs/monthly-behavioural-support-modules/Month-8.pdf',
        moduleString: moduleStrings.MonthEight
    },
    9: {
        title: "Month 9",
        topics: [
            "Exercise & physical fitness refresher",
            "Activity tracker sheets"
        ],
        file: 'https://himalayas-space.nyc3.cdn.digitaloceanspaces.com/docs/monthly-behavioural-support-modules/Month-9.pdf',
        moduleString: moduleStrings.MonthNine
    },
    10: {
        title: "Month 10",
        topics: [
            "Social support",
            "Decision balance",
            "Activity tracker sheets"
        ],
        file: 'https://himalayas-space.nyc3.cdn.digitaloceanspaces.com/docs/monthly-behavioural-support-modules/Month-10.pdf',
        moduleString: moduleStrings.MonthTen
    },
    11: {
        title: "Month 11",
        topics: [
            "Activity tracker sheets"
        ],
        file: 'https://himalayas-space.nyc3.cdn.digitaloceanspaces.com/docs/monthly-behavioural-support-modules/Month-11.pdf',
        moduleString: moduleStrings.MonthEleven
    },
    12: {
        title: "Month 12",
        topics: [
            "Goal setting",
            "Time management",
            "Overcoming barriers",
            "Self monitoring",
            "Activity tracker sheets"
        ],
        file: 'https://himalayas-space.nyc3.cdn.digitaloceanspaces.com/docs/monthly-behavioural-support-modules/Month-12.pdf',
        moduleString: moduleStrings.MonthTwelve
    }
};

const SupportMonthly = () => {
    const [fireworks, setFireworks] = useState(false);
    const [userProfileId, setUserProfileId] = useState(auth.currentUser.uid);
    const [user, setUser] = useState();
    const [moduleToComplete, setModuleToComplete] = useState("");
    const [reportedFeedback, setReportedFeedback] = useState(true);
    const [completedModule, setCompletedModule] = useState(false);
    const [modal, setModal] = useState(false);
    const [monthModal, setMonthModal] = useState(false);
    const [selectedMonth, setSelectedMonth] = useState(null);
    const [modalMessage, setModalMessage] = useState("");
    const [modalTitle, setModalTitle] = useState("");
    const [feedback, setFeedback] = useState("");
    const toggle = () => setModal(!modal);
    const toggleMonthModal = () => setMonthModal(!monthModal);

    useEffect(() => {
      GetUserInformation(userProfileId, SetUserInfo);
    }, []);

    const SetUserInfo = (user) =>{
        if(user.modules === undefined){
            user.modules = [];
        }
        setUser(user);
    }

    const StartModule = (moduleName) => {
        var newUserInformation = user;
        var moduleObject = {
            moduleName: moduleName, 
            timeStarted: firebase.firestore.Timestamp.fromDate(new Date()),
            timeCompleted: "",
            completed: false,
        }

        if(newUserInformation.modules === undefined){
            var modules = [];
            modules.push(moduleObject);
            newUserInformation.modules = modules;
        }
        else{
            var modules = newUserInformation.modules;
            for(var i = 0; i < modules.length; i++){
                if(modules[i].moduleName === moduleObject.moduleName){
                    return;
                }
            }
            modules.push(moduleObject);
            newUserInformation.modules = modules;
        }
        UpdateUserInformation(userProfileId, newUserInformation);
    }

    const CompleteModule = (moduleName) => {
        setCompletedModule(false);
        setReportedFeedback(true);
        setModuleToComplete(moduleName);
        setModalTitle("Complete Module?");
        setModalMessage("Please make sure you have read through the full module before completing");
        toggle(true);
    }

    const ConfirmModuleCompletion = () => {
        var newProperties = user;
        for(let i = 0; i < newProperties.modules.length; i++){
            if(newProperties.modules[i].moduleName === moduleToComplete){
                newProperties.modules[i].completed = true;
                newProperties.modules[i].timeCompleted = firebase.firestore.Timestamp.fromDate(new Date());
            }
        }
        UpdateUserInformation(user.uid, newProperties, ShowModuleFeedback);
    }

    const ShowModuleFeedback = (success) => {
        if(success){
            setCompletedModule(true);
            setReportedFeedback(false);
            setModalTitle("Module Completed!");
            setModalMessage("Congratulations on completing your module, please leave some feedback on the module");
            setFireworks(true);
            setTimeout(function(){setFireworks(false);}, 5000);
        }
        else{
            setModalTitle("Something went wrong");
            setModalMessage("Something happened! Please contact an admin");
        }
    }

    const SendFeedback = () =>{
        if(feedback === ""){
            toggle(false);
            return;
        }
        OpenTicket(user.username, user.uid, user.email, TicketStrings.modulefeedback, feedback, false, FollowUpModuleFeedback);
    }

    const FollowUpModuleFeedback = (success) => {
        setReportedFeedback(true);
        if(success){
            setModalTitle("Feedback Received");
            setModalMessage("Thanks for your feedback!");
        }
        else{
            setModalTitle("Unable to submit feedback");
            setModalMessage("Something went wrong!");
        }
    }

    const handleMonthClick = (monthNumber) => {
        setSelectedMonth(monthNumber);
        toggleMonthModal();
    };

    const isMonthCompleted = (monthNumber) => {
        if (!user || !user.modules) return false;
        return user.modules.find(obj => 
            obj.moduleName === monthData[monthNumber].moduleString && obj.completed
        );
    };

    return (
        <React.Fragment>
            <StyledModal isOpen={modal}>
            {fireworks && <Fireworks />}
                <ModalHeader>{modalTitle}</ModalHeader>
                <ModalBody>
                    {modalMessage}
                    {!reportedFeedback && <hr />}
                    {!reportedFeedback && <StyledInput type="textarea" name="feedback" id="feedback" onChange={e => setFeedback(e.target.value)}/>}
                </ModalBody>
                <ModalFooter>
                    <Button color="secondary" onClick={toggle}>Close</Button>
                    {!completedModule && <Button color="primary" onClick={ConfirmModuleCompletion}>Complete</Button>}
                    {(!reportedFeedback && completedModule) && <Button color="primary" onClick={SendFeedback}>Submit Feedback</Button>}
                </ModalFooter>
            </StyledModal>
            
            <MonthModal 
                isOpen={monthModal}
                toggle={toggleMonthModal}
                monthData={selectedMonth ? monthData[selectedMonth] : null}
                user={user}
                onStart={StartModule}
                onComplete={CompleteModule}
            />
            
            <HeightDiv>
                <ParentDiv>
                    <StyledBackgroundImage />
                </ParentDiv>   
            </HeightDiv>
            <MarginDiv>
                <StyledContainer>
                    <Row>
                        <Col lg="6">
                            <RightMarginButton color="primary" href="/exercise-groups">Back to exercise groups Page</RightMarginButton>
                            <Button color="primary" href="/exercise-groups/modules-specific">Specific Modules</Button>
                            <h3><br />Monthly Behavioural Support Modules</h3>
                            <StyledParagraph>
                                New to exercise or want a more guided experience getting back into it? Follow our carefully developed 12-month exercise support plan that has been designed to help you start and maintain your new exercise routine.
                            </StyledParagraph>
                            <StyledParagraph>
                                Click on the module title (e.g. "Month 1") to start the module for your profile.
                            </StyledParagraph>
                        </Col>
                        <Col lg="6">
                            <MonthGrid>
                                {[1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12].map(monthNumber => (
                                    <MonthCard 
                                        key={monthNumber}
                                        monthNumber={monthNumber}
                                        isCompleted={isMonthCompleted(monthNumber)}
                                        onClick={handleMonthClick}
                                    />
                                ))}
                            </MonthGrid>
                        </Col>
                    </Row>
                </StyledContainer>
            </MarginDiv>
        </React.Fragment>
     );
}

export default SupportMonthly;

const MarginDiv = styled.div`
    margin-left: 15px;
    margin-right: 15px;
`

const PlaceholderImage = styled.img`
    width: 100%;
`

const RightMarginButton = styled(Button)`
    margin-right: 25px;
`

const StyledParagraph = styled.p`
    font-size: large;
`

const StyledListItem = styled.li`
    font-size: large;
`

const VideoCol = styled(Col)`
    min-height: 500px;
    margin-bottom: 30px;
`

const TableCol = styled(Col)`
    padding-top: 10px;
    border-style: solid;
    border-color: black;
    border-width: 1px;
`
 
const StyledContainer = styled(Container)`
    justify-content: center;
    box-shadow: 0 0.5rem 1rem #372844;
    border-radius: 10px;
    border-color: #9780af #372844 #372844 #9780af;
    border: solid;
    background-color: white;
    margin: auto;
    padding: 10px;
    max-width: 1500px;
    margin-top: 15px;
    margin-bottom: 90px;
`

const StyledBackgroundImage = styled.img`
    width: 100%;
    height: 100%;
    z-index: -1000;
    object-fit: cover;
    position: fixed;
    background-color: #dddddd;
`;

const HeightDiv = styled.div`
    height: 100vh;
    position: absolute;
    z-index: -1;
`;

const ParentDiv = styled.div`
    width: 100%;
    height: 100%;
    display: flex;
`;

const StyledModal = styled(Modal)`
    position: absolute;
    left: 30%;
    top: 40%;
    min-width: 30%;
`

const StyledInput = styled(Input)`
margin-left: 10px;
border-color: black;
&:focus{
    border-color: #372844;
    box-shadow: 0 0.5rem 1rem #9780af;
}
`
const MonthGrid = styled.div`
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    grid-template-rows: repeat(4, 1fr);
    gap: 10px;
    padding: 20px 20px 50px 20px;
    height: 430px;
    
    @media (max-width: 768px) {
        grid-template-columns: repeat(2, 1fr);
        grid-template-rows: repeat(6, 1fr);
        height: 630px;
        padding: 20px 20px 50px 20px;
    }
    
    @media (max-width: 576px) {
        grid-template-columns: 1fr;
        grid-template-rows: repeat(12, 1fr);
        height: 1230px;
        padding: 20px 20px 50px 20px;
    }
`;